export interface UserEntity {
  email: string;
  firstName: string;
  lastName: string;
}

export enum UserHitId {
  ME = 'ME',
  UNASSIGNED = 'UNASSIGNED',
  EMPTY = 'EMPTY',
}
